import React, { createContext, useContext, useEffect, useState } from "react";

export type DebugControlPosition = Pick<React.CSSProperties, "top" | "left">;

export const useDebugControlPositionHandlerFactory = (initialPos: DebugControlPosition) => {
    const [position, setPosition] = useState<DebugControlPosition>(initialPos);

    const resetPosition = () => setPosition(initialPos);

    return { position, setPosition, resetPosition };
};

type Handler = ReturnType<typeof useDebugControlPositionHandlerFactory>;

export const DebugControlPositionContext = createContext(undefined);

export const useDebugControlPosition = () => useContext(DebugControlPositionContext) as Handler;

export const useDebugControlPositionChanger = (newPos: DebugControlPosition) => {
    const { setPosition, resetPosition } = useDebugControlPosition();

    useEffect(() => {
        setPosition(newPos);

        return () => resetPosition();
    }, []);
};
